<template>
 <div>
   <ValidationObserver v-slot="{ handleSubmit }">
     <form @submit.prevent="handleSubmit(onSubmit)">
       <div style="display: flex; flex-direction: column; align-items: start" class="mt-4">
         <span>Bài viết có dấu hiệu đạo văn không?</span>
         <el-radio-group :disabled="readonly" v-model="optionValue" @change="handleChangeSelectOption" style="display: flex; flex-direction: column">
           <el-radio :label="'1'">Không</el-radio>
           <el-radio :label="'3'">Nghi ngờ gian lận</el-radio>
           <el-radio :label="'2'">Có</el-radio>
         </el-radio-group>
       </div>
       <hr class="my-4" />
       <div v-if="+optionValue === 2">
         <div style="display: flex; flex-direction: column; gap: 4px">
           <span>Tỉ lệ đạo văn của bài viết <span class="text-red-700">*</span></span>
           <ValidationProvider
               v-slot="{ errors }"
               name="Tỉ lệ đạo văn của bài viết"
               rules="required"
           >
             <el-select
                 v-model="cheating.type"
                 placeholder="Chọn"
                 size="large"
                 style="width: 240px"
                 clearable
                 :disabled="readonly"
             >
               <el-option
                   v-for="item in checkPlagiarismOption"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value"
               />
             </el-select>
             <div class="fv-plugins-message-container">
               <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                   errors[0]
                 }}
               </div>
             </div>
           </ValidationProvider>
         </div>

         <div class="my-4">
           <span class="mb-1 block">Nhận xét cụ thể, dẫn chứng<span style="color: red">*</span></span>
           <ValidationProvider
               v-slot="{ errors }"
               name="Nhận xét cụ thể, dẫn chứng"
               rules="required|min:50"
           >
             <el-input
                 v-model="cheating.description"
                 type="textarea"
                 rows="4"
                 class="!font-extralight"
                 placeholder="Nhận xét cụ thể, dẫn chứng"
                 :disabled="readonly"
             />
             <div class="fv-plugins-message-container">
               <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                   errors[0]
                 }}
               </div>
             </div>
           </ValidationProvider>
         </div>
       </div>

       <div v-if="+optionValue === 3" class="my-4">
         <span class="mb-1 block">Ghi chú nghi ngờ gian lận<span style="color: red">*</span></span>
         <ValidationProvider
             v-slot="{ errors }"
             name="Ghi chú nghi ngờ gian lận"
             rules="required"
         >
           <el-input
               v-model="cheating.description"
               type="textarea"
               rows="4"
               class="!font-extralight"
               placeholder="Nhập ghi chú nghi ngờ gian lận"
               :disabled="readonly"
           />
           <div class="fv-plugins-message-container">
             <div data-field="description" data-validator="notEmpty" class="fv-help-block">{{
                 errors[0]
               }}</div>
           </div>
         </ValidationProvider>
       </div>

       <div style="display:flex; justify-content: end">
         <el-button
             v-if="!(readonly && isLastTab)"
             native-type="submit"
             type="primary"
             class="text-white"
         >
           Tiếp theo
         </el-button>
       </div>
     </form>
   </ValidationObserver>
   <el-dialog
       :visible.sync="isConfirm"
       title="Xác nhận bài thi đạo văn từ 50% trở lên"
       width="500"
       :show-close="false"
       :before-close="handleClose"
       :close-on-click-modal="!readonly"
       :close-on-press-escape="!readonly"
   >
    <span>
      Khi chọn tỉ lệ đạo văn từ 50% trở lên, hệ thống sẽ tự động chấm kĩ năng này
      <span class="text-red-500 font-semibold">0 điểm</span> và kết thúc tác vụ này.
    </span>
     <span class="font-semibold flex mt-2">Bạn có chắc chắn muốn tiếp tục?</span>
     <span slot="footer" class="dialog-footer">
      <el-button @click="isConfirm = false" type="info">Hủy bỏ</el-button>
      <el-button type="primary" class="bg-header-color" @click="handleCheatingAndNext">Xác nhận</el-button>
    </span>
   </el-dialog>
 </div>
</template>

<script>
import { checkPlagiarismOption } from '@/common/define.js'
import {MARK_CHEATING} from "@/core/services/store/marking/marking.module";
import {SPEAKING, WRITING} from "@/common/courseTemplate";

export default {
  name: 'ExamPlagiarismCheck',
  props: {
    cheating: {
      type: Object,
      required: true,
      default: () => ({ type: null, description: '' })
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isLastTab: {
      type: Boolean,
      default: false
    },
    typeExam: {
      type: Number,
      default: 2 // WRITING
    },
    writingCount: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      optionValue: '1',
      isConfirm: false,
      checkPlagiarismOption
    }
  },
  watch: {
    cheating: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          const { type, description } = newVal
          const hasType = type !== null && type !== undefined
          const hasDescription = !!description

          if (type === 2) {
            this.optionValue = '3'
          } else if (hasType && hasDescription) {
            this.optionValue = '2'
          } else if (type === 0) {
            this.optionValue = '1'
          }
        }
      }
    }
  },
  methods: {
    handleClose() {
      this.isConfirm = false
    },
    handleChangeSelectOption() {
      if(+this.optionValue === 3) {
        this.cheating.type = 2
        return
      }
      this.cheating.type = null
      this.cheating.description = null
    },
    shouldShowConfirmation() {
      return this.cheating.type === 1 && !this.readonly
    },

    onSubmit() {
      if (this.shouldShowConfirmation()) {
        this.isConfirm = true
        return
      }
      this.$emit('nextStep', 'checkCheating')
    },

    async handleCheatingAndNext() {
      this.isConfirm = false
      const cheatingData = {
        type: 1,
        marking_retake_id: this.$route.query.marking_retake_id,
        description: this.cheating.description,
        has_submitted: true
      }
      this.$emit('cheatingNext', cheatingData)
    },
  }
}
</script>
